// removed by extract-text-webpack-plugin
module.exports = {"header":"_3xVAML-BLkUFdYfklJ4UXq","headerTitle":"_3SKJ33l6qz8gfIR4amyKpT","policyText":"_-6lnD5YR7YY6JJGUnLvZU","description":"_11U2p0C2pwhgka7QeU5nYw","agreementDescription":"TlUhssby-MXPt-Oj3e4wO","customPanel":"_1NhK3sZr1452QJc7wedaRU","customHeader":"d1VDFwUSYWwpFD-aFonVr","panelTitle":"-mfKERn9qmt6io4zcpB8O","rulePanel":"iVXM64bAsNG6fivXe8BlM","footer":"_1moaG5qa4JEKR0pUiOVk9d","termsAndConditionsText":"_1ib3zDmRAGfd5d0myuCGCS"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/PartnerAgreement/assets/css/page.css
// module id = 61
// module chunks = 0